var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"id":"id","value":_vm.duration,"formatter":_vm.durationFormatter,"lazy-formatter":"","required":_vm.required},on:{"blur":function($event){_vm.duration = $event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }